import { ListItemButton } from '@mui/material';
import List from '@mui/material/List';
import React from 'react';
import { Col, Grid, Row } from 'react-flexbox-grid/dist/react-flexbox-grid';
import { defineMessages, useIntl } from 'react-intl';
import {
  NavLink, Outlet, useLocation, useParams,
} from 'react-router-dom';
import Sticky from 'react-stickynode';
import Layout from '../../../App/components/Layout/LayoutContainer';
import { fetchEmailPreferences } from '../../../EmailPreferences/EmailPreferencesActions';
import { getToken } from '../../../Auth/AuthReducer';
import styles from '../SettingsPage/SettingsPage.css';

const messages = defineMessages({
  profileSettings: {
    id: 'AccountSettings.ProfileSettings',
    defaultMessage: 'Security',
  },
  emailSettings: {
    id: 'AccountSettings.EmailSettings', 
    defaultMessage: 'Email Preferences',
  },
  back: {
    id: 'AccountSettings.Back',
    defaultMessage: 'Back',
  },
  title: {
    id: 'AccountSettings.Title',
    defaultMessage: 'Account Settings',
  },
});

const AccountSettingsPageLayout = () => {
  const { page } = useParams();
  const { formatMessage } = useIntl();
  const { pathname } = useLocation();
  const levels = pathname.split('/').filter(Boolean).length;
  const pages = [
    'profile',
    'email',
  ];

  return (
    <Layout 
      returnLinkText={levels > 2 ? formatMessage(messages.back) : null} 
      returnLinkTo="back"
      title={formatMessage(messages.title)}
    >
      <Grid className={styles['main-grid']} fluid>
        <Row className={styles['main-content']}>
          <Col xs={12} sm={5} md={3} lg={3} id="accountSettingsCol">
            <Sticky innerZ={1} bottomBoundary="#accountSettingsCol" enabled>
              <List>
                {pages.map(key => (
                  <ListItemButton
                    component={NavLink}
                    to={`/account/${key}`}
                    selected={key === page}
                    className={styles.listItem}
                    key={key}
                  >
                    {formatMessage(messages[`${key}Settings`])}
                  </ListItemButton>
                ))}
              </List>
            </Sticky>
          </Col>
          <Col xs={12} sm={7} md={9} lg={9}>
            <Outlet />
          </Col>
        </Row>
      </Grid>
    </Layout>
  );
};

AccountSettingsPageLayout.loader = store => () => {
  const state = store.getState();
  const token = getToken(state);
  // Load email preferences data
  return store.dispatch(fetchEmailPreferences(token));
};

export default AccountSettingsPageLayout; 